"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructuredDataUtils = void 0;
var StructuredDataUtils = /** @class */ (function () {
    function StructuredDataUtils() {
    }
    StructuredDataUtils.insertToDOM = function (data) {
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
    };
    return StructuredDataUtils;
}());
exports.StructuredDataUtils = StructuredDataUtils;
